import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';

// Create Vue app
const app = createApp(App);
app.use(createPinia());
app.mount('#dataagent-order-dom');
